module.exports = __webpack_public_path__ + "media/images/gray_jean-b4a96946cd732f0ba65a31d1cb899622.png";